import React from 'react';
import { Box, Typography } from '@mui/material';

/** `auth` — larger mark + wordmark for sign-in / auth cards. `nav` — sidebar header. */
const Logo = ({ showText = true, showIcon = true, size = 'default' }) => {
  const auth = size === 'auth';
  const nav = size === 'nav';
  const imgHeight = auth ? 26 : nav ? 24 : 22;
  const textSize = auth ? 20 : nav ? 18 : 18;
  const fontWeight = auth ? 700 : nav ? 500 : 700;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      {showIcon && (
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="PromptCrew"
          sx={{
            height: imgHeight,
            width: 'auto',
            objectFit: 'contain',
            mr: auth ? 0.75 : nav ? 0.625 : 0.5,
            display: 'block'
          }}
        />
      )}
      {showText && (
        <Typography
          noWrap
          component="div"
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontSize: textSize,
            fontWeight,
            lineHeight: `${imgHeight}px`,
            height: imgHeight,
            letterSpacing: nav ? 0 : undefined,
          }}
        >
          <Box component="span" sx={{ color: nav ? '#1F2937' : 'text.primary' }}>Prompt</Box>
          <Box component="span" sx={{ color: 'primary.main' }}>Crew</Box>
        </Typography>
      )}
    </Box>
  );
};

export default Logo;

